import { ICommand } from 'core-ts-types';
import { IDisplayMessageService } from '../../../global/services/display_message_service';

export class DisclaimerLanguageController {
  legalDisclaimer?: string;
  constructor(private ngDisplayMessageService: IDisplayMessageService) {}

  $onInit() {
    this.legalDisclaimer = this.ngDisplayMessageService('legal_disclaimer').text;
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngDisclaimerLanguageController', DisclaimerLanguageController)
  .component('disclaimerLanguage', {
    templateUrl: 'lib/transfer/components/disclaimer_language/disclaimer_language.html',
    controllerAs: '$ctrl',
    controller: 'ngDisclaimerLanguageController',
    bindings: {
      legalDisclaimer: '@'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/disclaimer_language/disclaimer_language.ts